// @flow

import React, { type Node } from 'react';
import { TipsBox } from '../../../../organisms/tips-box';

import qrCodeIcon from './qr-code-icon.svg';
import downloadQrCodeIcon from './check-icon.svg';
import clockIcon from './clock-icon.svg';

import { getName } from '@tectonics/prs/merchant';
import { useIncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';

export function Instructions(): Node {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  const merchantName = getName(merchant);

  return (
    <TipsBox title="Payment instructions" tipsModel={[
      {
        imgSrc: qrCodeIcon,
        altText: 'qrcode icon',
        tipText: 'Open your UPI app an scan the QR code above',
      },
      {
        imgSrc: downloadQrCodeIcon,
        altText: 'download qrcode icon',
        tipText: (
          <>
            Review the transaction details and confirm payment from <strong> { merchantName } </strong>.
            Your purchase will be confirmed instantly.
          </>
        ),
      },
      {
        imgSrc: clockIcon,
        altText: 'download qrcode icon',
        tipText: 'The request will be valid for 5 minutes. Complete the transaction in time to proceed with your order.',
      },
    ]} />
  );
}
